import { types } from 'mobx-state-tree';
import Actions from './Actions';
import Views from './Views';
const UBP = types
    .model({
    bulkShowCredits: types.maybe(types.integer),
    totalBulkShowCredits: types.maybe(types.integer),
})
    .views(Views)
    .actions(Actions);
export default UBP;
